(function () {
    'use strict';
    angular.module('app.dp', ['ngMaterial', 'app.giteditor', 'ngTable']);
})();
